import { useCallback } from 'react';

import { NewRequestWhere } from '@/domain/newRequest';
import { MIXPANEL_ACTIONS, mixpanelTracking } from '@/mixPanel/mixPanelActions';
import { REQUEST_STATUS } from '@/utils/enums/requestsPage';

type TrackAbsenceApprovalParams = {
    isDeletionRequest: boolean;
    absenceName: string | undefined;
    status: REQUEST_STATUS;
    where?: NewRequestWhere;
};

const useTrackAbsenceApproval = () => {
    const trackApproval = useCallback(
        ({ isDeletionRequest, absenceName, status, where }: TrackAbsenceApprovalParams) => {
            if (status === REQUEST_STATUS.ACCEPTED) {
                isDeletionRequest
                    ? mixpanelTracking(MIXPANEL_ACTIONS.DELETION_REQUEST_APPROVED_SUCCESSFULLY, { absenceName })
                    : mixpanelTracking(MIXPANEL_ACTIONS.APPROVED_REQUEST, { absenceName, where });
            } else {
                mixpanelTracking(MIXPANEL_ACTIONS.REJECTED_REQUEST, { absenceName, where });
            }
        },
        []
    );

    return { trackApproval };
};

export default useTrackAbsenceApproval;
